var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VAutocomplete',_vm._g({attrs:{"outlined":"","value":_vm.value,"items":_vm.sections,"rules":_vm.rules,"loading":_vm.loading,"disabled":_vm.disabled,"item-text":"section","item-value":"id","label":"Section","return-object":"","clearable":""}},_vm.inputListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }